/**
 * @file Contains dialog constants
 */

import { DialogId } from '../models/dialog';

/**
 * Type for Dialog content
 */
type DialogContent = {
  cancelLabel: string;
  confirmLabel: string;
  description: string;
  title: string;
};

/**
 * Mapping between dialog type and its content
 *
 * @summary It is used only in compose dialog (currently)
 */
export const dialogMap: Record<DialogId, DialogContent> = {
  [DialogId.ComposeChecklistClear]: {
    cancelLabel: 'GENERAL__GO_BACK',
    confirmLabel: 'CHECKLIST__CLEAR',
    description: 'CHECKLISTS__CLEAR_CONFIRM__TITLE',
    title: 'CHECKLISTS__CLEAR_CONFIRM',
  },
  [DialogId.ComposeClear]: {
    cancelLabel: 'GENERAL__CANCEL',
    confirmLabel: 'GENERAL__CLEAR_FORM',
    description: 'GENERAL__CLEAR_FORM__TITLE',
    title: 'GENERAL__CLEAR_FORM_CONFIRM',
  },
  [DialogId.ComposeClose]: {
    cancelLabel: 'GENERAL__GO_BACK',
    confirmLabel: 'GENERAL__CLOSE_WITHOUT_SAVING',
    description: 'MODAL__CONFIRM_CLOSE',
    title: 'GENERAL__YOUR_CHANGES_NOT_SAVED',
  },
};
